import { render, staticRenderFns } from "./Unidade.vue?vue&type=template&id=6d9fcc5a&scoped=true&"
import script from "./Unidade.vue?vue&type=script&lang=js&"
export * from "./Unidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9fcc5a",
  null
  
)

export default component.exports